import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BadgeOptions } from 'app/components/badge/badge.interface';
import { CustomFieldsOptions } from '../../../components/custom-fields/custom-fields.interface';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { EmployeeService } from 'app/core/services/employees/employee.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import * as dayjs from 'dayjs';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'employee-summary-preview',
  templateUrl: './employee-summary-preview.component.html',
  styleUrls: ['./employee-summary-preview.component.scss'],
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class EmployeeSummaryPreviewComponent implements OnInit, OnChanges {
  @Input() userId: any = '';
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  customFieldGroups: any = {};
  object = Object;
  loaded: boolean = false;

  tabs: any[] = [{
    displayName: 'Primary Details',
    displayKey: 'text.primary_details',
    dataKey: 'PrimaryDetails',
    rel: 'primary_details'
  }, {
    displayName: 'Work Hours',
    displayKey: 'text.work_hours',
    dataKey: 'WorkHours',
    rel: 'work_hours'
  }];
  viewMode: string = 'PrimaryDetails';
  workDetails: any[] = [];
  employeeDetails: any = {};
  skills: any[] = [];
  teams: any[] = [];
  masterCustomFields: any[] = [];
  skillBadgeOptions: BadgeOptions = {
    type: 'EXPIRED',
    displayKey: 'expired',
    displayName: 'Expired'
  };
  displayedColumns: string[] = ['WORK_DAY', 'FROM_TIME', 'TO_TIME', 'WORK_MINS'];

  constructor(
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private customFieldServie: CustomFieldGroupService,
    private employeeService: EmployeeService,
    private utilityService: UtilityService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.getEmployeeDetails();
    this.changeDetectorRef.markForCheck();
  }

  changeViewMode(mode: string): void {
    this.viewMode = mode;
    this.changeDetectorRef.markForCheck();
  }

  closeDrawer(): void {
    this.eventEmitter.emit({ drawerClose: true });
    this.changeDetectorRef.markForCheck();
  }

  validateExpirationDate(date: string): boolean {
    return dayjs(date).isBefore(dayjs());
  }

  getEmployeeDetails(): void {
    this.loaded = false;
    forkJoin([
      this.dataCollectorService.getData(this.employeeService.getUserURL(this.userId)),
      this.dataCollectorService.getData(this.employeeService.getWorkHoursURL(this.userId)),
      this.dataCollectorService.getData(this.employeeService.getTeamsURL(this.userId)),
      this.dataCollectorService.getData(this.employeeService.getSkillsURL(this.userId)),
      this.dataCollectorService.getData(this.customFieldServie.getModuleCustomFieldsUrl('EMPLOYEE'))])
      .subscribe(
        ([employeeDetails, workHours, teams, skill, customFields]: any) => {
          this.employeeDetails = employeeDetails.data;
          this.workDetails = workHours.data;
          this.teams = teams.data;
          this.skills = skill.data;
          this.masterCustomFields = customFields.data;
          this.workDetails = this.workDetails.filter(value => value.is_enabled === true);
          if ((employeeDetails.type && customFields.type && teams.type && skill.type) === 'success') {
            this.getCustomFieldGroups();
          }
          this.loaded = true;
          this.changeDetectorRef.markForCheck();
        }, (_error: any) => {
          this.loaded = true;
          this.changeDetectorRef.markForCheck();
        });
  }

  getCustomFieldGroups(): void {
    this.customFieldGroups = this.customFieldServie.getCustomFieldGroups(this.masterCustomFields, this.employeeDetails.custom_fields);
    this.changeDetectorRef.markForCheck();
  }

  getRedirectLink(): string {
    return this.utilityService.getLink('EMPLOYEE', this.employeeDetails.user_uid);
  }

  getcustomFieldOptions(data: any): CustomFieldsOptions {
    return {
      data: data,
      displayInColumn: 1,
      extraClass: 'px-0',
      labelAlign: 'Left'
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.userId?.firstChange === false){
      this.getEmployeeDetails();
      this.changeDetectorRef.markForCheck();
    }
  }
}
